import PageShell from "@/components/feature/PageShell";
import HeroCarousel from "./components/HeroCarousel";
import WorksQuickLinks from "./components/WorksQuickLinks";
import LatestNews from "./components/LatestNews";
import TagCloud from "./components/TagCloud";

export default function Home() {
  return (
    <PageShell>
      <HeroCarousel />
      <WorksQuickLinks />
      <LatestNews />
      <TagCloud />
    </PageShell>
  );
}